// extracted by mini-css-extract-plugin
export default {"Navigation":"navigation_Navigation__eGqFv","item":"navigation_item__aqSQS","current":"navigation_current__LTdrk"};